import { Component, ElementRef } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { SingService } from '../service/sing.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'dealer-left-menu-comp',
    templateUrl: 'left-menu/left-menu.html',
    styleUrls: ['add-access/bootstrap.min.css', 'add-access/update.css', 'add-access/style.css'], //left-menu/style.min.css
})
export class DealerLeftMenuComponent {
    leftDate: any = [
        ['Jan', 'Feb', 'Mar', 'Apr'],
        ['May', 'Jun', 'Jul', 'Aug'],
        ['Sep', 'Oct', 'Nov', 'Dec'],
    ];
    leftDateR: any = ['Week', 'Month', 'Quarter', 'Year'];
    leftMenu: any = [
        { text: 'Edit products', view: 'edit-products' },
        {
            text: 'Upload Budget file',
            view: 'upload-budget-file',
        },
        { text: 'Edit rooftop settings', view: 'edit-rootftop' },
        {
            text: 'Add access list',
            view: 'add-access',
        },
        { text: 'Events', view: 'events' },
        { text: 'Dashboard settings', view: 'dashboard-settings' },
    ];

    constructor(
        private broadcaster: Broadcaster,
        private elRef: ElementRef,
        private httpService: SingService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() { }

    ShowDate(): void {
        $('.search-main-search-select').toggle();
        $('.mask').toggle();
    }

    UpdateFirstLeft(id: number): string {
        if (id === 0) {
            return 'active-menu';
        }
        return '';
    }

    SelectItemMenu(id: number) {
        //$('.drawer').drawer('close');
        $('.menu-left .menu-left-item').removeClass('active-menu');
        $('.menu-left .menu-left-item')
            .eq(id)
            .addClass('active-menu');
        // ModelData.setView($scope.leftMenu[id].view);
        this.broadcaster.broadcast('update', {
            item: id,
        });
    }

    AddRooftop() {
        /*$scope.rightMenu.push(
     {id: "nav-ford-south", text: "Ford"}
     );*/
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dealer/dealer-left-menu.component.ts